import React, { useEffect } from 'react';
import { Typography, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CommonColors } from '@/Themes';
import { ROUTERS } from '@constants';
import Utils from '@/Utils';

const VerifyAccountSuccess: React.FC = () => {
  // Constructors

  useEffect(() => {
    Utils.sleep(5000).then(() => Utils.redirect(ROUTERS.AUTH));
  }, []);

  // Events
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor={CommonColors.mainBackground}
    >
      <Grid item>
        <CheckCircleIcon color="success" fontSize="large" />
      </Grid>
      <Grid item>
        <Typography variant="h4">
          Verify account successfully! System will redirect after 5 seconds...
        </Typography>
      </Grid>
    </Grid>
  );
};

export default VerifyAccountSuccess;
